var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            dontShowAgainCookie: _vm.FOODS_DISCLAIMER_COOKIE_NAME,
            cancelFn: function() {
              _vm.$router.go(-1)
            }
          },
          model: {
            value: _vm.showDisclaimerDialog,
            callback: function($$v) {
              _vm.showDisclaimerDialog = $$v
            },
            expression: "showDisclaimerDialog"
          }
        },
        [
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.$t("foods.disclaimer")) }
          })
        ]
      ),
      _vm._v(" "),
      _c("MicrohabitCategoriesPanelMenu", {
        attrs: { type: _vm.MICROHABIT_FOOD_TYPE }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43343bf3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43343bf3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/foods/FoodCategoriesPanelMenu.vue
// module id = 4057
// module chunks = 72